export default __webpack_public_path__ + "static/media/2017.71c6ecce.png";